import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import { Slider } from "@mui/material";

import { i18n } from "../../translate/i18n";
import AerosDialog from "../AerosDialog";
import useAerosModalStyles from "../../styles/aerosModalStyles";
import { AEROS, stateText } from "../../styles/aerosTokens";

const useStyles = makeStyles((theme) => ({
  row: { display: "flex", alignItems: "center", gap: 16, padding: "8px 4px" },
  pct: {
    width: 44,
    flex: "none",
    fontSize: 13,
    fontWeight: 700,
    fontVariantNumeric: "tabular-nums",
    color: stateText(theme, AEROS.cyan, "info"),
  },
  pctB: { textAlign: "right", color: stateText(theme, "#C08BFF", "purple") },
  slider: { flex: 1, color: AEROS.cyan },
}));

const FlowBuilderRandomizerModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const m = useAerosModalStyles();
  const [percent, setPercent] = useState(0);
  const [activeModal, setActiveModal] = useState(false);

  useEffect(() => {
    if (open === "edit") {
      setPercent(data.data.percent);
      setActiveModal(true);
    } else if (open === "create") {
      setPercent(0);
      setActiveModal(true);
    }
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleValue = (event, newValue) => {
    setPercent(newValue);
  };

  const handleSaveContact = async () => {
    if (!percent || parseInt(percent) <= 0) {
      return toast.error(i18n.t("aeros.flow.modals.randomizer.errorEmpty"));
    }
    if (open === "edit") {
      onUpdate({
        ...data,
        data: { percent: percent },
      });
    } else if (open === "create") {
      onSave({
        percent: percent,
      });
    }
    handleClose();
  };

  return (
    <AerosDialog
      open={activeModal}
      onClose={handleClose}
      width={480}
      title={i18n.t(open === "edit" ? "aeros.flow.modals.randomizer.editTitle" : "aeros.flow.modals.randomizer.addTitle")}
      onSubmit={handleSaveContact}
      submitLabel={i18n.t(open === "edit" ? "aeros.flow.save" : "aeros.flow.add")}
    >
      <div>
        <label className={m.fieldLabel}>{i18n.t("aeros.flow.modals.randomizer.label")}</label>
        <div className={classes.row}>
          <span className={classes.pct}>{percent}%</span>
          <Slider
            className={classes.slider}
            aria-label={i18n.t("aeros.flow.modals.randomizer.label")}
            value={percent || 0}
            valueLabelDisplay="auto"
            onChange={handleValue}
            step={10}
            marks
            min={0}
            max={100}
          />
          <span className={`${classes.pct} ${classes.pctB}`}>{100 - percent}%</span>
        </div>
        <div className={m.hint}>{i18n.t("aeros.flow.modals.randomizer.hint", { a: percent, b: 100 - percent })}</div>
      </div>
    </AerosDialog>
  );
};

export default FlowBuilderRandomizerModal;
